import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";

import type { UserMemory } from "../types";

interface UserMemoriesResponse {
  results: UserMemory[];
}

const USER_MEMORIES_QUERY_KEY = ["user-memories"] as const;

export const useGetUserMemories = () => {
  return useQuery({
    queryKey: USER_MEMORIES_QUERY_KEY,
    queryFn: () => axiosInstance.get<UserMemoriesResponse>("/memory"),
    select: (data) => data.data.results,
  });
};

export const useForgetMemory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => axiosInstance.delete(`/memory/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_MEMORIES_QUERY_KEY });
    },
  });
};
